import React from "react";
import { Box, Typography, Paper } from "@mui/material";
import { PiLinkBreakBold } from "react-icons/pi";

import { LogoIcon } from "./icons/LogoIcon";

const LinkExpiredPage: React.FC = () => {
  return (
    <Box
      sx={{
        minHeight: "100vh",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        p: 2,
        background: "linear-gradient(180deg, #F7F5FC 0%, #FFFFFF 55%)",
      }}
    >
      <Paper
        elevation={0}
        sx={{
          width: "100%",
          maxWidth: 420,
          textAlign: "center",
          borderRadius: 4,
          border: "1px solid rgba(145, 88, 206, 0.14)",
          boxShadow: "0 24px 48px -24px rgba(39, 35, 102, 0.28)",
          px: 5,
          py: 6,
        }}
      >
        <Box
          sx={{
            width: 64,
            height: 64,
            borderRadius: "50%",
            mx: "auto",
            mb: 3,
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            background:
              "linear-gradient(135deg, rgba(39, 35, 102, 0.08), rgba(145, 88, 206, 0.18))",
          }}
        >
          <PiLinkBreakBold size={28} color="#9158CE" />
        </Box>

        <Typography
          variant="h5"
          sx={{ fontWeight: 700, color: "text.primary" }}
        >
          Chat Closed
        </Typography>
        <Typography sx={{ mt: 1.5, color: "text.secondary", lineHeight: 1.6 }}>
          This chat has ended or the link is no longer valid. You can close this tab.
        </Typography>
      </Paper>
    </Box>
  );
};

export default LinkExpiredPage;
